module.exports = __webpack_public_path__ + "img/binance_api_ip_3.73940024.png";